import { render, staticRenderFns } from "./TrainingResultTag.vue?vue&type=template&id=7562f3de&scoped=true&"
import script from "./TrainingResultTag.vue?vue&type=script&lang=ts&"
export * from "./TrainingResultTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7562f3de",
  null
  
)

export default component.exports